import React from 'react'
import { Box, CircularProgress, Typography, Backdrop } from '@mui/material'

interface LoadingProps {
  /** Show as full-page backdrop */
  fullPage?: boolean
  /** Loading message (optional) */
  message?: string
  /** Size of spinner (default: 40) */
  size?: number
}

/**
 * Reusable loading component
 * Can be used inline or as full-page backdrop
 */
const Loading: React.FC<LoadingProps> = ({ fullPage = false, message, size = 40 }) => {
  const content = (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 2,
        p: 3
      }}>
      <CircularProgress size={size} />
      {message && (
        <Typography variant='body2' sx={{
          color: 'text.secondary'
        }}>
          {message}
        </Typography>
      )}
    </Box>
  )

  if (fullPage) {
    return (
      <Backdrop
        open={true}
        sx={{
          color: 'common.white',
          zIndex: theme => theme.zIndex.drawer + 1,
          backgroundColor: 'rgba(0, 0, 0, 0.7)',
        }}>
        {content}
      </Backdrop>
    )
  }

  return content
}

export default Loading
